import React, { FC } from 'react';
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';
import { IExceptionWord } from '../../types/exceptionWord';
import {
  ExceptionWordDialog,
  ExceptionWordDialogType,
} from '../Dialogs/ExceptionWordDialog';
import { DeleteExceptionWordDialog } from '../Dialogs/DeleteExceptionWordDialog';
import classes from './ExceptionWordsTable.module.scss';

type Props = {
  list: IExceptionWord[];
  handleEdit: (value: IExceptionWord) => Promise<IExceptionWord>;
  fetchData: () => void;
};

type RowProps = {
  word: IExceptionWord;
  style: ReturnType<typeof useStyles>;
} & Pick<Props, 'handleEdit' | 'fetchData'>;

const useStyles = makeStyles({
  root: {
    background: '#FF7221 !important',
    borderRadius: '0 !important',
    width: 160,
    color: '#FFFFFF !important',
    textTransform: 'none',
    fontWeight: '550 !important',
    // color: '#FFFFFF',
    '&:hover, &:focus': {
      background: '#DE6109',
    },
    fontFamily: 'HelveticaNeueCyr',
    // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
    height: 38,
    fontSize: 14,
    padding: '0 30px',
  },
  restore: {
    textTransform: 'none',
    background: 'white !important',
    width: 160,
    height: 38,
    fontSize: 14,
    fontFamily: 'HelveticaNeueCyr',
    color: '#FF7221 !important',
    border: '1px solid #FF7221 !important',
    borderRadius: '0 !important',
    fontWeight: '550 !important',
    marginRight: '24px !important',
  },
});

const ExceptionWordsTableRow: FC<RowProps> = ({
  word,
  style,
  handleEdit,
  fetchData,
}) => (
  <tr className={classes.tr}>
    <td>
      <p>{word.word}</p>
    </td>
    <td style={{ width: '25%' }}>
      <ExceptionWordDialog
        type={ExceptionWordDialogType.EDIT}
        initialValue={word}
        onSubmit={handleEdit}
        fetchData={fetchData}
      >
        <Button className={style.restore}>Редактировать</Button>
      </ExceptionWordDialog>

      <DeleteExceptionWordDialog word={word} fetchData={fetchData} />
    </td>
  </tr>
);

export const ExceptionWordsTable: FC<Props> = ({
  list,
  handleEdit,
  fetchData,
}) => {
  const style = useStyles();

  return (
    <>
      {list.map((word) => (
        <ExceptionWordsTableRow
          word={word}
          style={style}
          key={word.id}
          handleEdit={handleEdit}
          fetchData={fetchData}
        />
      ))}
    </>
  );
};
